import React, { useState } from 'react';
import { Modal, Button, Select, message, Pagination } from 'antd';
import { SiteAPI } from '../../requests';
import { useFetchList, useTitle } from '../../hooks';
import { CreateCard } from '../../components';
import OfficialAccountItem from './OfficialAccountItem/OfficialAccountItem';
import './style.less';

interface AccountItemProps {
  headImg: string,
  name: string,
  newMsgCount: number,
  newUserCount: number,
  userCount: number,
  siteId: string
}

const clsPrefix = 'cn-of-accs-list';
const { Option } = Select;
const OfficialAccountsListContainer:React.FC<{}> = () => {
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [chosenSite, setChosenSite] = useState('')

  useTitle('公众号列表');

  const {
    isDone,
    items,
    loadMore,
    loading,
  } = useFetchList(SiteAPI.getSiteList, {
    page: 1,
    querys: {
      perpage: 10
    }
  })

  const {
    items: accountItems,
    total: accountTotal,
    changeQuerys,
    page,
  } = useFetchList(SiteAPI.getOffAccountList, {
    page: 1,
    size: 8,
  })

  function handleCreateClick() {
    setCreateModalVisible(true);
  }
  
  function handleToCreate() {
    window.location.href = 'https://www.kuaizhan.com/v3/site/template/1';
    setCreateModalVisible(false);
    setChosenSite('')
  }

  function handleConfirmBind() {
    if (!chosenSite || chosenSite.length < 1) {
      message.info('请选择一个站点')
      return;
    }
    window.location.href = `https://www.kuaizhan.com/weixin/bind?scene_type=13&site_id=${chosenSite}`;
    setCreateModalVisible(false);
  }

  const isScrollToBottom = (containerHeight: number, scrollHeight: number, scrollTop: number) => {
    return scrollTop + containerHeight === scrollHeight
  }

  const fetchSiteList = (e: any) => {
    if (isDone || loading) {
      return;
    }
    if (isScrollToBottom(e.target.clientHeight, e.target.scrollHeight, e.target.scrollTop)) {
      loadMore();
    }
  }

  const jumpToNewVersion = () => {
    window.location.href = '/v3/weixin/list'
  }

  return(
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__part`}>
        <div className={`${clsPrefix}__part--title`}>
          <div>公众号管理列表</div>
          <span
            onClick={jumpToNewVersion}
            style={{
              color: '#D40424',
              fontSize: '16px',
              marginLeft: '20px',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            体验新版
          </span>
        </div>
        <div className={`${clsPrefix}__part--container`}>
          {
            page === 1 && 
              <CreateCard 
                height='402px'
                width='230px'
                content='绑定新公众号'
                handleClick={handleCreateClick}
              />
          }
          {
            // @ts-ignore
            accountItems && accountItems.map((item: AccountItemProps) => (
              <OfficialAccountItem 
                logoPic={item.headImg}
                title={item.name}
                todayNews={item.newMsgCount}
                todayNewUsers={item.newUserCount}
                allUsers={item.userCount}
                siteId={item.siteId}
              />
            ))
          }
          {/* {
            accountItems.length < 8 && 
              <CreateCard 
                height='402px'
                width='230px'
                content='绑定新公众号'
                handleClick={handleCreateClick}
              />
          } */}
        </div>    
        <div className={`${clsPrefix}__part--pagination`}>
          <Pagination 
            simple
            size="small"
            total={accountTotal + 1}
            pageSize={8}
            onChange={(pageNum) => changeQuerys({
              page: pageNum
            })}
          />
        </div> 
      </div>
      <Modal
        visible={createModalVisible}
        title="绑定站点"
        style={{ top: '154px' }}
        width="466px"
        onCancel={() => {
          setCreateModalVisible(false);
          setChosenSite('');
        }}
        footer={[
          <Button 
            key="ok" 
            type="primary"
            size="large"
            style={{ width: '213px'}}
            onClick={handleConfirmBind}
          >
            立即绑定
          </Button>,
          <Button 
            key="cancel" 
            onClick={handleToCreate}
            style={{ width: '213px'}}
            type="primary"
            size="large"
            ghost
          >
            新建站点
          </Button>,
        ]}
      >
        <div>选择公众号要绑定的站点 ：</div>
        <Select 
          className={`${clsPrefix}__select`}
          onPopupScroll={e => fetchSiteList(e)}
          placeholder="请选择一个站点"
          onChange={(value: string) => setChosenSite(value)}
          allowClear
        >
          {
            items && items.map((item) => {
            // @ts-ignore
              return <Option key={item.id} value={item.id}>{item.name}</Option>
            })
          }
        </Select>
      </Modal>
    </div>
  )
}

export default OfficialAccountsListContainer;